export default "__VITE_ASSET__795UXYNU__"